const SessionResponse = function(location, jwt) {
  this.location = location
  this.jwt = jwt
}

export default SessionResponse


/** WEBPACK FOOTER **
 ** ./components/service-provider/session-response.js
 **/